export const SENSOR_CHIP_SX = {
  fontWeight: 600,
  fontSize: "0.6875rem",
  justifyContent: "center",
};
